// ProfesionalCard.jsx
import React, { useState, useEffect } from "react";
import { Building2 } from "lucide-react";
const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:3005";

const ProfesionalCard = ({ isOpen, onClose, company }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    website: "",
    descripcion: "",
    role: "",
  });



  // Cuando se abra el popup, si hay empresa seleccionada, rellenamos los datos
  useEffect(() => {
    if (company) {
      setFormData({
        nombre: company.name || "",
        website: company.website || "",
        descripcion: company.description || "",
        role: company.role || "",
      });
    } else {
      setFormData({
        nombre: "",
        website: "",
        descripcion: "",
            role: "",
      });
    }
  }, [company, isOpen]);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  // Guardar empresa (POST o PUT según corresponda)
  const saveCompanyData = async (companyData) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("No estás autenticado. Por favor, inicia sesión.");
        window.location.href = "/";
        return null;
      }

      const method = company ? "PUT" : "POST";
      const url = company
        ? `${baseUrl}/company/${company._id}` // editar
        : `${baseUrl}/company/`; // nueva

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(companyData),
      });

      const data = await response.json();
      if (!response.ok) {
        alert(data.message || "Error al guardar la empresa");
        return null;
      }
      return data;
    } catch (error) {
      console.error("Error al guardar la empresa:", error);
      alert("Error al guardar la empresa");
      return null;
    }
  };

  const saveData = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("No se encontró el usuario.");
      return;
    }

    const companyData = {
      name: formData.nombre,
      companyImage: "",
      description: formData.descripcion,
      website: formData.website,
    };

    // Guardamos la empresa (POST o PUT)
    const savedCompany = await saveCompanyData(companyData);
    if (!savedCompany) return;

    // Si es edición, terminamos aquí
    if (company) {
      alert("Ficha profesional actualizada con éxito");
      window.location.reload();
      return;
    }

    // Si es nueva empresa → la vinculamos al usuario
    const companyId = savedCompany.company._id;
    const body = { role: formData.role, companyId };

    try {
      const response = await fetch(
        `${baseUrl}/users/addCompany/${userId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        alert(data.message || "Error al guardar la ficha profesional");
        return;
      }

      alert("Ficha profesional guardada con éxito");
      window.location.reload();
    } catch (error) {
      console.error("Error al guardar la ficha profesional:", error);
      alert("Error al guardar la ficha profesional");
    }
  };

  const handleSubmit = () => {
    if (
      !formData.nombre ||
      !formData.website ||
      !formData.descripcion ||
      !formData.role
    ) {
      alert("Por favor, completa todos los campos.");
      return;
    }
    saveData();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="dyd-overlay"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="dyd-modal"
      >
        <div className="dyd-modal-head">
          <span className="dyd-modal-icon"><Building2 size={20} /></span>
          <h2>
          {company ? "Editar ficha profesional" : "Añadir ficha profesional"}
        </h2>
        </div>

        {/* Nombre */}
        <div className="dyd-field">
          <label className="dyd-label">
            Nombre
          </label>
          <input
            type="text"
            value={formData.nombre}
            onChange={handleChange("nombre")}
            placeholder="Nombre de la empresa"
            className="dyd-input"
          />
        </div>

        {/* Website */}
        <div className="dyd-field">
          <label className="dyd-label">
            Website
          </label>
          <input
            type="text"
            value={formData.website}
            onChange={handleChange("website")}
            placeholder="Página web"
            className="dyd-input"
          />
        </div>

        {/* Descripción */}
        <div className="dyd-field">
          <label className="dyd-label">
            Descripción
          </label>
          <textarea
            value={formData.descripcion}
            onChange={handleChange("descripcion")}
            placeholder="Breve descripción"
            rows={3}
            className="dyd-textarea"
          />
        </div>

        {/* Rol */}
        <div className="dyd-field">
          <label className="dyd-label">Rol</label>
          <input
            type="text"
            value={formData.role}
            onChange={handleChange("role")}
            placeholder="Indica tu rol dentro de la empresa"
            className="dyd-input"
          />
        </div>

        {/* Botón Guardar */}
        <button
          onClick={handleSubmit}
          className="dyd-btn dyd-btn-primary"
        >
          {company ? "Guardar cambios" : "Guardar"}
        </button>

        {/* Botón Cerrar */}
        <button
          onClick={onClose}
          className="dyd-btn dyd-btn-subtle"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ProfesionalCard;
